import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";
import { useEffect, useState } from "react";
import UserTransferList from "../../components/user-transfer-list/user-transfer-list.component";
import dataProvider from "../../providers/data-provider";
import { Save } from "@material-ui/icons";

const SchedulingAddManager = ({ record, resource, refresh, path, title, disabled, ...props }) => {
    const [open, setOpen] = useState(false);
    const [users, setUsers] = useState([]);
    const [selected, setSelected] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getData = async () => {
            const response = await dataProvider.getList(
                'user-contexts',
                {
                    pagination: { page: 1, perPage: 999 },
                    sort: { field: 'user.name', order: 'ASC' },
                    filter: {
                        'profiles': ['\'Administrador\'', '\'Coordenador\'', '\'Advogado\'', '\'Advogado parfista\'', '\'Professor\'', '\'Professor gestor\'', '\'Advogado geral\''],
                        'active': true,
                        'institution_branch': record.institution_branch?.id,
                        'with_general_lawyer': true,
                    }
                }
            )
            setUsers(response.data)
        }
        getData();
    }, [record]);

    const handleSubmit = () => {
        setLoading(true)
        dataProvider.create(`${resource}/${record.id}/${path}`, { data: { users: selected } })
            .then(() => { refresh(); setTimeout(() => { }, 2000) })
            .finally(() => { setLoading(false); setOpen(false); })
    }

    const handleClose = () => {
        setOpen(false)
        setSelected([])
    }

    const filterUsers = (data) => {
        return data.filter(item => !record.managed_by?.find(i => i.id === item.id))
    };

    return (
        <div style={{ width: '100%', textAlign: 'left' }}>
            <Dialog maxWidth={"lg"} fullWidth open={open} onClose={handleClose}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent dividers style={{ overflow: 'hidden' }}>
                    <UserTransferList
                        data={filterUsers(users)}
                        selected={selected}
                        setSelected={setSelected}
                    />
                    <DialogActions>
                        <Button onClick={handleClose} size={'medium'} variant={'contained'} color={'default'}> Cancelar </Button>
                        <span style={{ flexGrow: 1 }} />
                        <Button
                            onClick={handleSubmit}
                            size={'medium'}
                            variant={'contained'}
                            color={'primary'}
                            startIcon={loading ? <CircularProgress size={16} /> : <Save />}
                            disabled={loading || selected.length === 0}
                        >
                            Confirmar
                        </Button>
                    </DialogActions>
                </DialogContent>
            </Dialog>
            <Button onClick={() => setOpen(true)} size={'small'} variant={'contained'} color={'primary'} disabled={disabled}>
                Adicionar usuários
            </Button>
        </div>
    )
};

export default SchedulingAddManager;
